var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 5.33398H12.0007C12.3543 5.33398 12.6934 5.47446 12.9435 5.72451C13.1935 5.97456 13.334 6.3137 13.334 6.66732V14.6673C13.334 15.0209 13.1935 15.3601 12.9435 15.6101C12.6934 15.8602 12.3543 16.0007 12.0007 16.0007H6.66732C6.3137 16.0007 5.97456 15.8602 5.72451 15.6101C5.47446 15.3601 5.33398 15.0209 5.33398 14.6673V6.66732C5.33398 6.3137 5.47446 5.97456 5.72451 5.72451C5.97456 5.47446 6.3137 5.33398 6.66732 5.33398Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 21.334H12.0007C12.3543 21.334 12.6934 21.4745 12.9435 21.7245C13.1935 21.9746 13.334 22.3137 13.334 22.6673V25.334C13.334 25.6876 13.1935 26.0267 12.9435 26.2768C12.6934 26.5268 12.3543 26.6673 12.0007 26.6673H6.66732C6.3137 26.6673 5.97456 26.5268 5.72451 26.2768C5.47446 26.0267 5.33398 25.6876 5.33398 25.334V22.6673C5.33398 22.3137 5.47446 21.9746 5.72451 21.7245C5.97456 21.4745 6.3137 21.334 6.66732 21.334Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 16H25.3327C25.6863 16 26.0254 16.1405 26.2755 16.3905C26.5255 16.6406 26.666 16.9797 26.666 17.3333V25.3333C26.666 25.687 26.5255 26.0261 26.2755 26.2761C26.0254 26.5262 25.6863 26.6667 25.3327 26.6667H19.9993C19.6457 26.6667 19.3066 26.5262 19.0565 26.2761C18.8065 26.0261 18.666 25.687 18.666 25.3333V17.3333C18.666 16.9797 18.8065 16.6406 19.0565 16.3905C19.3066 16.1405 19.6457 16 19.9993 16Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 5.33398H25.3327C25.6863 5.33398 26.0254 5.47446 26.2755 5.72451C26.5255 5.97456 26.666 6.3137 26.666 6.66732V9.33398C26.666 9.68761 26.5255 10.0267 26.2755 10.2768C26.0254 10.5268 25.6863 10.6673 25.3327 10.6673H19.9993C19.6457 10.6673 19.3066 10.5268 19.0565 10.2768C18.8065 10.0267 18.666 9.68761 18.666 9.33398V6.66732C18.666 6.3137 18.8065 5.97456 19.0565 5.72451C19.3066 5.47446 19.6457 5.33398 19.9993 5.33398Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentcolor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7047a9286f4c9ad113143bc996dfaa3c.svg";
export { ForwardRef as ReactComponent };